module.exports = __webpack_public_path__ + "img/renanburda.c7db1677.jpeg";